import type { VideoItem } from "@/types/video";
import VideoCard from "@/components/feature/VideoCard";
import EmptyState from "@/components/base/EmptyState";

interface VideoGridProps {
  videos: VideoItem[];
  columns?: string;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyActionLabel?: string;
  emptyActionTo?: string;
}

export default function VideoGrid({
  videos,
  columns = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
  emptyTitle = "暂无内容",
  emptyDescription = "这里还没有可展示的影视资源，去看看最新上线的内容吧。",
  emptyActionLabel = "查看最新上线",
  emptyActionTo = "/",
}: VideoGridProps) {
  if (!videos || videos.length === 0) {
    return (
      <EmptyState
        icon="ri-film-line"
        title={emptyTitle}
        description={emptyDescription}
        actionLabel={emptyActionLabel}
        actionTo={emptyActionTo}
      />
    );
  }

  return (
    <div className={`grid ${columns} gap-x-4 gap-y-6 md:gap-x-5 md:gap-y-8`}>
      {videos.map((video) => (
        <VideoCard key={video.id} video={video} />
      ))}
    </div>
  );
}